<template>
  <div
    v-if="showModuleModal"
    class="modal top-0 bottom-0 w-full h-full fixed flex justify-center items-center"
  >
    <div class="overlay fixed w-full h-full top-0"></div>
    <div class="modal-content w-full relative">
      <!-- close button -->
      <div
        @click="close"
        class="close absolute flex flex-row justify-center items-center text-white cursor-pointer"
      >
        <img :src="require('../../assets/close.png')" alt="" />
      </div>

      <div class="bg-white px-8 py-4 ">
        <div class="modal-title main-tenant-color font-semibold mb-2">
          New Module
        </div>
        <div class="flex flex-row flex-wrap">
          <div class="flex flex-col flex-wrap flex-grow items-start mr-12">
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold">Module Title:</div>
              <div class="flex-grow ml-auto">
                <linput
                  type="text"
                  name="fname"
                  v-model="form.title"
                  :errorMessage="errors.title"
                  :error="errors.title"
                  placeholder="Title of Module"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Description:</div>
              <div class="flex-grow ml-auto">
                <ltextarea
                  v-model="form.description"
                  :errorMessage="errors.description"
                  :error="errors.description"
                  placeholder="Module Description"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col flex-grow items-start">
            <div class="flex flex-row items-center form-row mb-8">
              <div class="modal-field font-semibold ">Module Number:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.module_number"
                  :error="errors.module_number"
                  :errorMessage="errors.module_number"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Module Duration:</div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.duration"
                  :error="errors.duration"
                  :errorMessage="errors.duration"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-center items-center">
          <div class="mb-2">
            <lms-button @click="handleFormSubmit">Add Module</lms-button>
          </div>
          <!-- <div class="mb-12 cursor-pointer" style="color:#102767 ">
						Import from csv 
					</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      errors: [],
      form: {},
    };
  },
  model: {
    prop: "showModuleModal",
    event: "closeModuleModal",
  },
  props: {
    showModuleModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  mounted() {
    this.form = {};
  },
  methods: {
    ...mapActions(["tenantCreateModule"]),
    async handleFormSubmit() {
      this.errors = [];
      let res = await this.tenantCreateModule({
        id: this.$route.params.id,
        module: this.form,
      });

      if (res == true || res.status == 200 || res.status == 201) {
        this.form = {};
        this.$emit("notify", {
          type: "success",
          message: "Module created successfully",
        });

        this.close();
      } else {
        if (res.status == 400) {
          this.$Bus.$emit("notify", {
            type: "error",
            message: res.data.errors
              ? res.data.errors[0].title
              : "An error occured",
          });
        }
      }
    },
    close() {
      this.form = {};
      this.$emit("closeModuleModal", false);
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-tenant);
    }

    .modal-field {
      color: color(lms-tenant);
      max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
      top: -17px;
      z-index: 2;
      right: -16px;
    }
    z-index: 1;
  }
}
</style>
